import { contactUsConstants } from '../constants/actionTypes'

const initialState = {
  modeOfContact: 'phone',
  isSubmitted: false,
  isLoading: false,
  hasSubmissionFailed: false,
}

export default function contactUsReducer(state = initialState, action) {
  switch (action.type) {
    case contactUsConstants.UPDATE_MODE_OF_CONTACT_TO_PHONE:
      return {
        ...state,
        modeOfContact: 'phone',
        hasSubmissionFailed: false,
      }
    case contactUsConstants.UPDATE_MODE_OF_CONTACT_TO_EMAIL:
      return {
        ...state,
        modeOfContact: 'email',
        hasSubmissionFailed: false,
      }
    case contactUsConstants.SUCCESS_CONTACT_CONSULTANT_SUBMISSION:
      return {
        ...state,
        isSubmitted: true,
        isLoading: false,
        hasSubmissionFailed: false,
      }
    case contactUsConstants.FAILURE_CONTACT_CONSULTANT_SUBMISSION:
      return {
        ...state,
        isSubmitted: false,
        isLoading: false,
        hasSubmissionFailed: true,
      }
    case contactUsConstants.INPROGRESS_CONTACT_CONSULTANT_SUBMISSION:
      return {
        ...state,
        isLoading: true,
      }
    case contactUsConstants.RESET_STATUS_CONTACT_CONSULTANT:
      return {
        ...state,
        isSubmitted: false,
        isLoading: false,
        hasSubmissionFailed: false,
      }
    default:
      return state
  }
}
